module.exports = __webpack_public_path__ + "img/theRain.c46cf3d5.svg";